import {
  icons,
  getTestAttributes,
  noop,
  DropdownWithOptions,
  DropdownOption,
  IconButton,
  ButtonSize,
  ButtonType,
  backgroundColorTransition,
  colors,
  fontSizing,
  fontWeights,
  sizing,
} from '@chillibean/component-library';
import { Icon } from '@iconify/react';
import { clsx } from 'clsx';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export function AdminCard(props) {
  const {
    disabled = true,
    header,
    id,
    onClick,
    onDelete = noop,
    onDuplicate = noop,
    rightSectionEnabled = false,
    subHeader = '',
  } = props;

  const dropdownOptions = () => {
    return [
      new DropdownOption({
        id: 'duplicate-protocol',
        label: 'Duplicate Trial Configuration',
        onClick: () => onDuplicate(id),
      }),
      new DropdownOption({
        disabled: disabled,
        id: 'delete-protocol',
        label: 'Delete Trial Configuration',
        onClick: () => onDelete(id),
        tooltip: 'A locked trial configuration cannot be deleted.',
      }),
    ];
  };

  return (
    <CardContainer
      key={id}
      className={clsx({
        'card-disabled': disabled,
      })}
      onClick={() => onClick(id)}
      {...getTestAttributes('admin-card')}
    >
      <HeaderContainer>
        <Header {...getTestAttributes('admin-card-header')}>{header}</Header>
        {subHeader && <Subheader {...getTestAttributes('admin-card-subheader')}>{subHeader}</Subheader>}
      </HeaderContainer>
      {rightSectionEnabled && (
        <IconsContainer>
          <Icon
            key="lock-icon"
            color={colors.black.medium}
            height={20}
            icon={disabled ? icons.baselineLock : icons.baselineUnlock}
            id={id}
            onClick={noop}
            width={20}
          />
          <DropdownWithOptions items={dropdownOptions(id)}>
            <IconButton
              icon={icons.baselineMoreVert}
              size={ButtonSize.SLIM}
              type={ButtonType.TERTIARY}
              {...getTestAttributes(`kebab-menu`)}
            />
          </DropdownWithOptions>
        </IconsContainer>
      )}
    </CardContainer>
  );
}

AdminCard.propTypes = {
  disabled: PropTypes.bool,
  header: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClick: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onDuplicate: PropTypes.func,
  rightSectionEnabled: PropTypes.bool,
  subHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
};

const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${sizing.medium};
  background-color: ${colors.white.primary};
  border-radius: ${sizing.xsmall};
  border: 1px solid ${colors.black.primary};
  cursor: pointer;

  min-height: 67px; // ! min height to keep cards without subheader the same height as the ones with subheader

  &:hover {
    background-color: ${colors.blue.mediumAlpha};
    ${backgroundColorTransition}
  }

  &.card-disabled {
    background-color: ${colors.grey.secondary};
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  font-size: ${fontSizing.medium};
  font-weight: ${fontWeights.bold};
  color: ${colors.black.medium};
`;

const Subheader = styled.div`
  font-size: ${fontSizing.small};
  font-weight: ${fontWeights.normal};
  color: ${colors.grey.medium};
`;

const IconsContainer = styled.div`
  display: flex;
  gap: ${sizing.medium};
  align-items: center;
`;

export default AdminCard;
